import { DEFAULT_CODECOMMIT_ROUTES } from '@localstack/constants';
import { ReactElement } from 'react';
import { CreateRepositoryInput } from '@localstack/types';
import { Breadcrumbs, CodeCommitRepositoryForm, ProgressButton } from '@localstack/ui';
import { useAwsEffect, useAwsGetter, useRoutes } from '@localstack/services';
import { Box, Card, CardActions, CardContent, Typography } from '@mui/material';

import { useParams } from 'react-router-dom';

import { CodeCommitProps } from './types';

export const CodeCommitRepositoryUpsert = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_CODECOMMIT_ROUTES,
}: CodeCommitProps): ReactElement => {
  const { goto } = useRoutes();
  const { id } = useParams<'id'>();
  const { data: repository } = useAwsGetter('CodeCommit', 'getRepository', [{ repositoryName: id }], {
    clientOverrides,
  });
  const { createRepository, isLoading } = useAwsEffect('CodeCommit', ['createRepository'], {
    clientOverrides,
    revalidate: ['listRepositories', 'getRepository'],
  });

  const handleCreate = async (data: CreateRepositoryInput) => {
    if (await createRepository(data)) {
      goto(routes.RESOURCES_CODECOMMIT_REPOSITORIES);
    }
  };

  return (
    <Layout
      documentTitle="CodeCommit: Create Repository"
      title={
        <Box>
          <Typography variant="h4">Create Repository</Typography>
          <Breadcrumbs
            mappings={[
              ['CodeCommit', () => goto(routes.RESOURCES_CODECOMMIT_REPOSITORIES)],
              [id, () => goto(routes.RESOURCES_CODECOMMIT_REPOSITORY, { id })],
              ['Create Repository', null],
            ]}
          />
        </Box>
      }
      actions={
        <ProgressButton
          color="primary"
          variant="outlined"
          type="submit"
          form="CodeCommitRepositoryUpsert"
          loading={isLoading}
        >
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <CodeCommitRepositoryForm
            formId="CodeCommitRepositoryUpsert"
            onSubmit={handleCreate}
            repository={repository}
            loading={isLoading}
          />
        </CardContent>
        <CardActions>
          <ProgressButton
            color="primary"
            variant="outlined"
            type="submit"
            form="CodeCommitRepositoryUpsert"
            loading={isLoading}
          >
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
